import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { share, switchMap, } from 'rxjs/operators';
import { ConfigService } from 'src/app/core/services/config.service';
import { OrderingParty } from '../models/OrderingParty';
import { OrderingPartySearchResultItem } from '../models/OrderingPartySearchResultItem';
import { SearchOrderingPartiesCriteria } from '../models/SearchOrderingPartiesCriteria';

@Injectable({
  providedIn: 'root'
})
export class OrderingPartyService {

  constructor(private http: HttpClient,
              private configService: ConfigService ) { }


  public getAllOrderingParties( ): Observable<OrderingParty[]> {

      return this.http.get<OrderingParty[]>(
        this.configService.PortalWebApiUrl + 'orderingParty/all' )
        .pipe(
          switchMap( r => {  return of<OrderingParty[]>(r); } ),
          share({ connector: () => new ReplaySubject(1)}),
        );
  }

  public getOrderingParty(id: number): Observable<OrderingParty> {
    return this.http.get<OrderingParty>(
      this.configService.PortalWebApiUrl + 'OrderingParty/' + id);
  }

  public storeOrderingParty(data: OrderingParty): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'orderingParty/store', data);
  }

  public searchOrderingParties(criteria: SearchOrderingPartiesCriteria): Observable<OrderingPartySearchResultItem[]> {
    return this.http.post<OrderingPartySearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'orderingParty/search', criteria);
  }

  public removeOrderingParty(id:number): Observable<number> {
    return this.http.delete<number>(
      this.configService.PortalWebApiUrl + 'orderingParty/remove/' +  id);
  }

}
